import type { Currency, SuretyAccountId } from "@inrev/common";
import {
	useFetchBalanceSheets,
	useFetchFinancialPeriods,
	useFetchIncomeStatements,
} from "@portal/api/financials";
import type { BalanceSheet, FinancialPeriodDto, IncomeStatement } from "../utils";
import { useFinancialsMetrics } from "./useFinancialsMetrics";

const EMPTY_PERIODS: FinancialPeriodDto[] = [];
const EMPTY_INCOME_STATEMENTS: IncomeStatement[] = [];
const EMPTY_BALANCE_SHEETS: BalanceSheet[] = [];

export type UseRecentFyeRevenueResult = {
	fyeRevenue: Currency | undefined | null;
	isLoading: boolean;
};

export const useRecentFyeRevenue = (accountId: SuretyAccountId): UseRecentFyeRevenueResult => {
	const { financialPeriods, financialPeriodsLoading } = useFetchFinancialPeriods(accountId);
	const { incomeStatements, incomeStatementsLoading } = useFetchIncomeStatements(accountId);
	const { balanceSheets, balanceSheetsLoading } = useFetchBalanceSheets(accountId);

	const { recentFYE } = useFinancialsMetrics(
		financialPeriods ?? EMPTY_PERIODS,
		incomeStatements ?? EMPTY_INCOME_STATEMENTS,
		balanceSheets ?? EMPTY_BALANCE_SHEETS,
	);

	return {
		fyeRevenue: recentFYE?.incomeStatement?.view?.revenue.total.allowed,
		isLoading: financialPeriodsLoading || incomeStatementsLoading || balanceSheetsLoading,
	};
};
